module.exports = __webpack_public_path__ + "img/reservation.4d6fb7f9.jpg";